<template>
  <b-container class="wrap-archive">
    <b-row class="box-head">
      <b-col
        cols="12"
        md="8"
        class="box-breadcrumb"
      >
        <b-breadcrumb :items="breadcrumbs" />
      </b-col>

      <b-col
        cols="12"
        md="4"
        class="box-back-btn"
      >
        <button @click.prevent="goBack()">
          Back to archive
        </button>
      </b-col>
    </b-row>

    <b-col
      cols="12"
      class="box-title pl-0"
    >
      <h2 class="category-title">
        {{ categoryName }}
      </h2>
    </b-col>

    <div v-if="isLoading" class="loading">
      <pulse-loader
        :loading="true"
        color="#000000"
        class="loader"
      />
    </div>
       <b-row v-if="!isLoading && subIds.length !== 0" class="wrap-content">
      </b-row>

    <b-row v-if="!isLoading && subIds.length !== 0" class="wrap-content">
      <b-col
        v-for="(subId,index) in subIds"
        :key="subId.id"
        :index="index"
        cols="12"
      >
       <div  v-if="subHeads[index].head_sub && index != 0 && subHeads[index].head_sub != subHeads[index-1].head_sub" class="category-box-detail">
          <div class="box" />
           <div class="content-head">
            <p>{{subHeads[index].head_sub}} </p>
           </div>
       </div>
        <div  v-if="subHeads[index].head_sub && index == 0 " class="category-box-detail">
          <div class="box" />
           <div class="content-head">
            <p>{{subHeads[index].head_sub}} </p>
           </div>
       </div>
        <hr>
        <div class="ml-5">
            <div class="category-box-detail">
              <div class="box" />
              <div class="content">
                <p>{{ subId.name }}</p>
              </div>
            </div>

            <!-- achive.category[0].id === subId.id -->
            <b-row class="wrap-achive">
              <b-col
                v-for="achive in newSubCategories"
                :key="achive.id"
                v-show="achive.category[0].id.toString() === subId.id.toString()"
                sm="12"
                md="6"
                lg="4"
                class="section"
              >
                <span v-if="achive.id === 0" class="noaward">NO AWARD</span>
                <div v-if="achive.id !== 0"
                  @mouseover="hoverCard(achive.id, true)"
                  @mouseleave="hoverCard(achive.id, false)"
                >
                  <router-link
                    :to="{
                      name: 'winnerArchiveDetail',
                      params: {
                        year,
                        categoryName,
                        name: achive.name.toLowerCase().replace(/<[^>]*>?/gm, '')
                      },
                      query: {
                        id: achive.id
                      }
                    }"
                  >
                    <div class="wrap-image">
                      <img
                        :src="achive.image"
                        :alt="achive.name"
                      >
                      <div
                        :class="isHover && achive.id === showDec ? 'box-dec-wrapper box-dec-wrapper--open' : 'box-dec-wrapper box-dec-wrapper--close'"
                      >
                        <div class="box-wrapper">
                          <div class="rank">
                            <div class="text">
                              <div
                                class="tab"
                                :style="[
                                  achive.level.toLowerCase() === 'gold' ? { backgroundColor: '#f7dc63' } : {},
                                  achive.level.toLowerCase() === 'silver' ? { backgroundColor: '#c2baa6' } : {},
                                  achive.level.toLowerCase() === 'bronze' ? { backgroundColor: '#f4b04d' } : {},
                                  achive.level.toLowerCase() === 'best' ? { backgroundColor: '#E10100' } : {}
                                ]"
                              >
                                <p>{{ achive.level }}</p>
                              </div>
                              <p
                                class="title"
                                :style="[
                                  achive.level.toLowerCase() === 'gold' ? { color: '#f7dc63' } : {},
                                  achive.level.toLowerCase() === 'silver' ? { color: '#c2baa6' } : {},
                                  achive.level.toLowerCase() === 'bronze' ? { color: '#f4b04d' } : {},
                                  achive.level.toLowerCase() === 'best' ? { color: '#E10100' } : {}
                                ]"
                              >
                                Award
                              </p>
                            </div>
                          </div>

                          <div class="content">
                            <h3 v-html="achive.name" class="title" />

                            <div class="detail">
                              <!-- <div class="box" /> -->
                              <p v-if="achive.id === 269" class="text brand" v-html="achive.brand" />
                              <p v-else class="text" v-html="achive.brand" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
              </b-col>
            </b-row>
        </div>
        <!-- end -->

        <!-- <b-row v-if="subcategory.achive.length === 0" class="wrap-achive--empty">
          <span>No Data</span>
        </b-row> -->
      </b-col>
    </b-row>

    <b-row v-if="!isLoading && subIds.length === 0" class="wrap-achive--empty ">
      <p>No Data </p>
    </b-row>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      breadcrumbs: [
        {
          text: 'Home',
          to: {
            name: 'home'
          }
        },
        {
          text: 'Winner Archive',
          to: {
            name: 'winnerArchive'
          }
        },
        {
          text: this.$route.params.categoryName.replace(/\b[a-zA-Z]/g, (match) => match.toUpperCase())
        }
      ],
      subIds: [],
      subHeads: [],
      showDec: null,
      isHover: false,
      newSubCategories: []
    }
  },

  computed: {
    ...mapState({
      categories: state => state.archive.categorys,
      isLoading: state => state.archive.isLoading,
      subCategories: state => state.archive.subcategory
    }),

    year () {
      return this.$route.params.year
    },

    categoryName () {
      return this.$route.params.categoryName
    }
  },

  metaInfo: {
    meta: [
      { name: 'publisher', content: 'admanawards.com/' },
      { name: 'og:url', content: 'https://admanawards.com' },
      { name: 'og:title', content: 'Adman Awards & Symposium 2019' },
      { name: 'og:description', content: 'งานประกวด แสดงผลงาน และแลกเปลี่ยนเรียนรู้ ของคนในวงการโฆษณาและการสื่อสารการตลาด' },
      { name: 'og:image', content: 'https://admanawards.com/img/og_adman.jpg' },
      { name: 'og:site_name', content: 'AdmanAwards' },
      { name: 'og:type', content: 'website' }
      // you can also add open graph tags here
    ]
  },

  watch: {
    categories (categories) {
      if (categories) {
        this.mapCategory(categories)
      }
    },

    async subCategories (subCategories) {
      if (subCategories) {
        this.subIds = await []
        const arrSubId = await []
        this.newSubCategories = []
        const subHead = await []
        this.subHeads = await []

        await subCategories.forEach((subCategory) => {
          this.newSubCategories.push({
            id: subCategory.id,
            name: subCategory.name,
            level: subCategory.level,
            brand: subCategory.brand,
            agency: subCategory.agency,
            production_company: subCategory.production_company,
            youtube_link: subCategory.youtube_link,
            image: subCategory.image,
            active: subCategory.categorysactive,
            category: subCategory.category
          })

          arrSubId.push({
            id: subCategory.category[0].id,
            name: subCategory.category[0].name_sub
          })

          subHead.push({
            id: subCategory.category[0].id,
            name: subCategory.category[0].name_sub,
            head_sub: subCategory.category[0].head_subcategory_id
          })
        })

        // Check duplicates in an array of objects
        const obj = await arrSubId.reduce((acc, c) => Object.assign(acc, { [c.id]: c.name }), {})
        // Order by id
        const output = await Object.keys(obj)
          .map(s => ({ id: s, name: obj[s] }))
          .sort((a, b) => a.id - b.id)

        this.subIds = await output

        const obj2 = await subHead.reduce((acc, c) => Object.assign(acc, { [c.id]: c.head_sub }), {})
        // Order by id
        const output2 = await Object.keys(obj2)
          .map(s => ({ id: s, head_sub: obj2[s] }))
          .sort((a, b) => a.id - b.id)

        this.subHeads = await output2
      }
    }
  },

  created () {
    this.$store.dispatch('archive/getCate')
  },

  methods: {
    goBack () {
      this.$router.push({ name: 'winnerArchive' })
    },

    mapCategory (categories) {
      categories.forEach((category) => {
        if (category.name.toLowerCase() === this.categoryName.toLowerCase()) {
          this.$store.dispatch('archive/getList', category.id)
        }
      })
    },

    hoverCard (index, status) {
      this.isHover = status

      if (status) {
        this.showDec = index
      } else {
        this.showDec = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.wrap-archive {
  .box-head {
      padding: 22px 0;
      border-bottom: 1px solid #CCC;

      .box-breadcrumb {
        display: flex;
        align-items: center;

        .breadcrumb {
          margin: 0;
          padding: 0;
          background: none;

          li {
            font-size: 1.25rem;

            a {
              color: black;
            }
          }
        }
      }

      .box-back-btn {
        margin-top: 22px;

        @media only screen and (min-width: $break-m) {
          margin-top: 0;
        }

        button {
          width: 100%;
          background-color: #CCC;
          padding: 12px 0;
          font-size: 1.25rem;
        }
      }
    }

  .box-title {
    .category-title {
      text-transform: uppercase;
      font-family: 'DB Helvethaica X 67 MedCond';
      letter-spacing: 10px;
      font-size: 68px;
      color: #6D6E71;
    }
  }

  .wrap-content {
    padding-bottom: 12px;

    .category-box-detail {
      display: flex;

      .box {
        margin-top: 10px;
        width: 20px;
        height: 20px;
        background-color: #E10100;
      }

      .content-head {
        margin-left: 12px;
        width: 100%;
        p {
          font-size: 52px;
          line-height: 42px;
        }
      }
      .content {
        margin-left: 12px;
        width: 100%;

        p {
          font-size: 44px;
          line-height: 38px;
        }

        hr {
          opacity: 0.3;
          margin-top: 6px;
          width: 100%;
          border: 0.5px solid #58595B;
        }
      }
    }

    .wrap-achive {
      margin-top: 22px;
      margin-bottom: 22px;

      .noaward {
        color: #E10100;
        font-size: 25px;
        padding-left: 33px;
      }

      .section {
        margin-bottom: 32px;

        a {
          .wrap-image {
            overflow: hidden;
            position: relative;
            width: 100%;
            padding-bottom: 56.25%;

            img {
              position: absolute;
              border: 0;
              width: 100%;
              height: 100%;
              background-color: #ccc;
            }
          }

          .box-dec-wrapper {
            position: absolute;
            top: 0;
            left: 0;
            padding: 18px;
            height: 100%;
            width: 100%;
            background-color: rgba(0, 0, 0, 0.85);

            .box-wrapper {
              position: relative;
              width: 100%;
              height: 100%;
              padding: 12px;
              border: 3px solid white;
            }

            .rank {
              overflow: hidden;
              position: absolute;
              right: 0;
              top: 0;
              height: 100%;

              .text {
                display: flex;

                .tab {
                  width: 25px;
                  height: 80px;
                  transform: translateX(24px);
                  margin-right: 8px;
                  font-family: 'DB Helvethaica X 67 Cond';
                  font-weight: 800;
                  font-size: 140px;
                  background-color: #ccc;

                  p {
                    transform: rotate(-90deg) translate(-46px, 2px);
                    top: 12px;
                    white-space: nowrap;
                    text-align: left;
                    text-transform: uppercase;
                    font-family: 'DB Helvethaica X 67 Cond';
                    font-size: 22px;
                    font-weight: 800;
                    color: #231F20;
                  }
                }

                .title {
                  transform: rotate(-90deg) translateX(-90px);
                  margin-top: -62px;
                  margin-right: -16px;
                  width: fit-content;
                  height: fit-content;
                  text-transform: uppercase;
                  font-size: 26px;
                  color: #ccc;
                }
              }
            }

            .content {
              width: 80%;
              height: 100%;

              .title {
                overflow: hidden;
                margin-left: 12px;
                text-overflow: ellipsis;
                text-transform: uppercase;
                font-family: 'DB Helvethaica X Med Cond';
                font-size: 24px;
                line-height: 26px;
                color: #C69C35;
                width: 100%;
              }

              .detail {
                display: -webkit-box;
                margin-top: 6px;

                .box {
                  margin-top: 6px;
                  width: 10px;
                  height: 10px;
                  background-color: #E10100;
                }

                .text {
                  overflow: hidden;
                  margin-left: 12px;
                  text-overflow: ellipsis;
                  font-family: 'DB Helvethaica X Li v3.2';
                  line-height: 21px;
                  font-size: 22px;
                  color: white;
                }
                .text.brand {
                  font-family: 'Roboto';
                  font-size: 16px;
                  line-height: 22px;
                }
              }
            }
          }

          .box-dec-wrapper--open {
            animation: open 300ms ease-out forwards;

            @keyframes open {
              from {
                transform: translateX(-100%);
              }

              to {
                transform: translateX(0);
              }
            }
          }

          .box-dec-wrapper--close {
            animation: close 200ms ease-out forwards;

            @keyframes close {
              from {
                transform: translateX(0);
              }

              to {
                transform: translateX(-100%);
              }
            }
          }
        }
      }
    }
  }
}
.wrap-achive--empty {
  display: flex;
  justify-content: center;
  padding-top: 45px;
  padding-bottom: 45px;
}
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 200px);
}
</style>
